















































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop } from 'vue-property-decorator';
import { CheckoutDetails, ReservationExpiration } from '@openticket/lib-shop';
import { intToDurationObject } from '@openticket/lib-utils';
import { IntSplitDuration } from '@openticket/lib-utils/lib/int_to_duration';
import { intToDuration } from '@/utils';
import OrderBarTotal from './OrderBarTotal.vue';

@Component({
    components: { OrderBarTotal },
})
export default class OrderBar extends Vue {
    @Prop() action!: string;
    @Prop() valid!: boolean;
    @Prop() visible!: boolean;
    @Prop() hasNextPage!: boolean;
    @Prop() disabled!: boolean;
    @Prop({ default: true }) showTotal!: boolean;

    details: CheckoutDetails | null = null;

    busy = false;
    busyTimer: number | null = null;

    isFree = false;
    isMounted = false;

    checkoutListener!: string;
    timerListener!: string;

    timer: number | null = null;

    get timerDuration(): string {
        return intToDuration(this.timer || 0);
    }

    get timerDurationObject(): IntSplitDuration {
        return intToDurationObject(this.timer || 0);
    }

    get showReservationTimer(): boolean {
        return (
            !this.$settings ||
            !this.$settings.static ||
            !this.$settings.static.shop ||
            this.$settings.static.shop.showReservationTimer ||
            this.$settings.static.shop.showReservationTimer === null
        );
    }

    public created(): void {
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        window.Loc = this.$time;

        this.checkoutListener = this.$shop.cart.on(
            'checkout',
            (path: string[], details: CheckoutDetails) => {
                // Update details
                this.details = details;

                // If there is already a timer running, stop it
                if (this.busyTimer) {
                    clearTimeout(this.busyTimer);
                    this.busyTimer = null;
                }

                if (details.busy) {
                    // if busy, start the new timer
                    this.busyTimer = window.setTimeout(() => {
                        this.busy = true;
                    }, 150);
                } else {
                    this.busy = false;
                }

                this.isFree =
                    this.$shop.cart.checkout_details.total_price === 0;
            }
        );

        this.details = this.$shop.cart.checkout_details;

        this.timerListener = this.$shop.events.on(
            ['timer'],
            async (path: string[], data: ReservationExpiration) => {
                this.timer = data.secondsRemaining;
            }
        );
    }

    mounted(): void {
        this.isMounted = true;
        this.isFree = this.$shop.cart.checkout_details.total_price === 0;
    }

    nextPage(): void {
        this.$emit('next');
    }

    placeOrder(): void {
        this.$emit('place-order');
    }

    destroyed(): void {
        this.$shop.off(this.checkoutListener);
        this.$shop.off(this.timerListener);
    }

    get reservationTranslationSlug(): string {
        if (this.timerDurationObject.days >= 1) {
            if (this.timerDurationObject.hours === 0) {
                return 'shop.notifications.reserved_for_days_zero_hours';
            } else if (this.timerDurationObject.hours === 1) {
                return 'shop.notifications.reserved_for_days_one_hour';
            }
            return 'shop.notifications.reserved_for_days_multiple_hours';
        } else if (this.timerDurationObject.hours >= 1) {
            if (this.timerDurationObject.minutes === 0) {
                return 'shop.notifications.reserved_for_hours_zero_minutes';
            } else if (this.timerDurationObject.minutes === 1) {
                return 'shop.notifications.reserved_for_hours_one_minute';
            }
            return 'shop.notifications.reserved_for_hours_multiple_minutes';
        } else if (this.timerDurationObject.minutes >= 1) {
            // DD-4E37 On shop order bar skip saying "Reserved for X minute." and say instead
            // "Reserved for X minute and 0 seconds". This prevents the string of becoming small and flashing for only
            // one second. However, for when the minutes are 0 we do say ""Reserved for X hour." instead of
            // "Reserved for X hour and 0 minutes.", since this state will last 1 minute and not change too quickly.
            if (this.timerDurationObject.seconds === 1) {
                return 'shop.notifications.reserved_for_minutes_one_second';
            }
            return 'shop.notifications.reserved_for_minutes_multiple_seconds';
        } else {
            return 'shop.notifications.reserved_for_seconds';
        }
    }

    get reservationTranslationCount(): number {
        if (this.timerDurationObject.days > 0) {
            return this.timerDurationObject.days;
        } else if (this.timerDurationObject.hours > 0) {
            return this.timerDurationObject.hours;
        } else if (this.timerDurationObject.minutes > 0) {
            return this.timerDurationObject.minutes;
        } else {
            return this.timerDurationObject.seconds;
        }
    }
}
